module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAQFJREFUOI2tU8t5xiAMk2iXIGOA72WVTpJkko4Scg9ZI1vEveB8NI/+h9Y3QJYl2wB/DN5dikhS1b4ek6oOALCu63jGvp0TvfdfABLJkeRcSvn03icA6Loue++xbdt8qRpC6GOMKiLpSe6vmBijhhB6U9KC2rOIpBjjZG/OmFV1aD2q6mSJqnokLMuSjeggeIisqlNNzvu+f9gDydGa/F4vhlLKMZEKziRNTXbOXRvXKMitxztgq6DaeGnhMaxnrQXzlCt7rkAA9wv0w8K5s6+qkzwmdlioKibbBQBwzs1tdRFJJAeTD5z+grG3u2+qbGwkR1N8IWiJKnhA7cc58d/iG/e9nGlxKo88AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliMoney.png
// module id = RIUn
// module chunks = 1